module.exports = __webpack_public_path__ + "static/media/ethereum.8f78322a.svg";